import { memo, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { Search } from '@mui/icons-material';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

import { TextInput } from './TextInput';

interface Props {
  search?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const SearchInput = memo(({ search = '', onChange: _onChange, placeholder = '', className }: Props) => {
  const { register, setValue } = useForm({
    defaultValues: {
      search,
    },
  });

  const handleChange = useCallback(
    (e: { target: { value: string } }) => {
      setValue('search', e.target.value);
      setTimeout(() => _onChange?.(e.target.value), 500);
    },
    [_onChange, setValue]
  );

  return (
    <TextInput
      register={register}
      registerProps={{
        onChange: handleChange,
      }}
      registerName="search"
      placeholder={placeholder}
      className={twMerge(clsx('col-span-1', className))}
      icon={Search}
      isSecondary
    />
  );
});
